import { createSlice } from "@reduxjs/toolkit";

const initialPlanBalanceState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  planBalanceForEdit: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const planBalanceSlice = createSlice({
  name: "planBalance",
  initialState: initialPlanBalanceState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getPlanBalanceById
    planBalanceFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.planBalanceForEdit = action.payload.planBalanceForEdit;
    },
    // findPlanBalance
    planBalancesFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    planBalanceReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
  },
});
